import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { booleanToYesNo, displaybleDate, InsurancePremiumSummary, notNullUndefined, SummaryEntityValue } from '@portal-workspace/grow-shared-library';
import { summaryEntityParties } from '@portal-workspace/grow-ui-library';
import { LoanPurposeSummaryComponent } from '../loan-purpose-summary/loan-purpose-summary.component';
import { CellComponent } from './cell.component';
import { ContactsSummaryComponent } from './contacts-summary.component';
import { EntitiesSummaryComponent } from './entities-summary.component';
import { EllipsisPipe } from '../../pipes/ellipsis.pipe';

@Component({
    selector: 'insurance-premium-summary',
    templateUrl: './insurance-premium-summary.component.html',
    styleUrls: ['./insurance-premium-summary.component.scss'],
    standalone: true,
    imports: [LoanPurposeSummaryComponent, EllipsisPipe, MatFormFieldModule, MatInputModule, FormsModule, CellComponent, MatDividerModule, ContactsSummaryComponent, EntitiesSummaryComponent]
})
export class InsurancePremiumSummaryComponent implements OnInit,OnChanges {

  booleanToYesNo = booleanToYesNo;
  displayableDate = displaybleDate;
  notNullUndefined = notNullUndefined;

  _entities?: SummaryEntityValue[];

  @Input({required: true}) summary!: InsurancePremiumSummary;

  ngOnInit(): void {
  }

  ngOnChanges(){
    this._entities = summaryEntityParties(this.summary?.applicants, undefined);
  }

}
